import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GroupDetailContainer from '../../containers/chancemng/group/GroupDetailContainer';

const GroupDetailPage = () => (
  <div>
    <BreadcrumbsContainer title="영업관리/영업기회 묶음/상세" icon="common" />
    <GroupDetailContainer />
  </div>
);

export default GroupDetailPage;
